import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Mail } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { toast } from './ui/sonner';

const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit';
const fieldClasses = 'bg-gray-900/50 border-gray-800 text-white placeholder:text-gray-500 focus-visible:ring-blue-600';

const Contact = () => {
  const { content } = useLanguage();
  const { contactForm: contact } = content.ui;
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch(WEB3FORMS_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          access_key: process.env.REACT_APP_WEB3FORMS_KEY,
          subject: contact.emailSubject,
          from_name: 'Qubo Car Tech - Website',
          ...formData
        })
      });
      const result = await response.json();

      if (result.success) {
        toast.success(contact.successMessage);
        setFormData({ name: '', email: '', message: '' });
      } else {
        toast.error(contact.errorMessage);
      }
    } catch (error) {
      toast.error(contact.errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contacto" className="py-20 lg:py-32 bg-black">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            {contact.title}
          </h2>
          <p className="text-lg text-gray-400">
            {contact.subtitle}
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-gradient-to-b from-gray-900 to-gray-950 border border-gray-800 rounded-2xl p-8 space-y-6"
        >
          <div>
            <label htmlFor="contact-name" className="block text-sm font-medium text-gray-300 mb-2">
              {contact.nameLabel}
            </label>
            <Input
              id="contact-name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder={contact.namePlaceholder}
              required
              className={fieldClasses}
            />
          </div>

          <div>
            <label htmlFor="contact-email" className="block text-sm font-medium text-gray-300 mb-2">
              {contact.emailLabel}
            </label>
            <Input
              id="contact-email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              placeholder={contact.emailPlaceholder}
              required
              className={fieldClasses}
            />
          </div>

          <div>
            <label htmlFor="contact-message" className="block text-sm font-medium text-gray-300 mb-2">
              {contact.messageLabel}
            </label>
            <Textarea
              id="contact-message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder={contact.messagePlaceholder}
              required
              rows={5}
              className={fieldClasses}
            />
          </div>

          <Button
            type="submit"
            disabled={isSubmitting}
            size="lg"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white transition-all duration-200"
          >
            {isSubmitting ? contact.submitting : contact.submit}
            <Mail className="ml-2" size={18} />
          </Button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
